import rill from "rill";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import getChallengeReport from "./challenge-report.controller";

const ChallengeReport = (app) => {
  app.at(
    "/challenge-report/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) =>
          checkOrganizationSectionPermission(
            ctx,
            next,
            ["PUSH"],
            "/coaching-portal/athletes"
          ),
        getChallengeReport
      );
    })
  );
};

export default ChallengeReport;
